export default function ChartToolTip({ payload, type }) {
  if (!payload || payload.length === 0) return null;

  const data = payload[0].payload;
  const color = payload[0].color || "#8884d8";

  switch (type) {
    case "slider":
      return (
        <div className="bg-white border border-gray-300 rounded px-3 py-2 text-sm">
          <div className="mb-1 font-medium text-black">
            Fascia: {data.label}
          </div>
          <div style={{ color }}>{`Risposte: ${data.value}`}</div>
        </div>
      );

    case "dual_counter":
      return (
        <div className="bg-white border border-gray-300 rounded px-3 py-2 text-sm">
          <div className="mb-1 font-medium text-black">
            {data.x} Auto, {data.y} Guidatori
          </div>
          <div style={{ color }}>{`Risposte: ${data.count}`}</div>
        </div>
      );

    case "multislider":
      return (
        <div className="bg-white border border-gray-300 rounded px-3 py-2 text-sm">
          <div className="mb-1 font-medium text-black">{data.label}</div>
          <div style={{ color }}>{`Media: ${data.value.toFixed(2)}%`}</div>
        </div>
      );

    default:
      return (
        <div className="bg-white border border-gray-300 rounded px-3 py-2 text-sm">
          <div className="mb-1 font-medium text-black">{data.answer}</div>
          <div style={{ color }}>{`Risposte: ${data.count}`}</div>
        </div>
      );
  }
}
